import { baseThemeValues } from 'constants/common';

export const rowCellTheme = {
  container: {
    borderColor: 'palette.tertiary.20:0.5',
    borderWidth: '1px',
    even: 'palette.surface.3',
    mainColumnEven: 'palette.surface.4',
    mainColumnOdd: 'palette.surface.5',
    odd: 'palette.surface.4',
    selected: 'palette.primary.10',
  },
  text: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '14px',
    fontWeight: 500,
    text: 'palette.tertiary.80',
  },
};
